import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => `${option.winthor} ${option.nome}`,
});

export const LOCAIS_SAIDA = [
  // { id: 1, nome: '-' },
  { id: 2, nome: 'LAMINADOS 1' },
  { id: 3, nome: 'LAMINADOS 2' },
  { id: 20, nome: 'LAMINADOS 3 ' },
  { id: 4, nome: 'RECHEADO' },
  { id: 5, nome: 'ROSCA' },
  { id: 6, nome: 'ASSISTEC' },
  { id: 7, nome: 'HASS' },
  { id: 8, nome: 'WAFER' },
  { id: 20, nome: 'OFICINA' },
  { id: 10, nome: 'SILOS' },
  { id: 11, nome: 'TERÇEIROS' },
  { id: 21, nome: 'UTILIDADES' },
  { id: 12, nome: 'PREDIAL' },
  { id: 13, nome: 'OUTROS' },
  { id: 14, nome: 'QUALIDADE' },
  { id: 15, nome: 'LIMPEZA' },
  { id: 16, nome: 'TI' },
  { id: 17, nome: 'ADM' },
  { id: 18, nome: 'RH' },
  { id: 19, nome: 'LOJA' },
];

export default function LinhaDeSaida({ setLinha, reset }) {
  const [value, setValue] = React.useState(null);
  const [inputValue, setInputValue] = React.useState('');

  React.useEffect(() => {
    setLinha('linha', value);
  }, [value]);

  React.useEffect(() => {
    if (!reset) {
      setValue(null);
    }
  }, [reset]);

  return (
    <Autocomplete
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'zIndex',
              enabled: true,
              phase: 'write',
              fn: ({ state }) => {
                state.styles.popper.zIndex = '9999';
              },
            },
          ],
        },
      }}
      className="bg-white z-50  rounded-md"
      sx={{ height: 44, border: 'none' }}
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      id="controllable-states-demo"
      options={LOCAIS_SAIDA}
      getOptionLabel={(option) => option.nome}
      isOptionEqualToValue={(option, value) => option.id === value?.id}
      filterOptions={filterOptions}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Digite local utilizado..." // Mantém o placeholder
          variant="outlined"
          // Input
          inputProps={{
            ...params.inputProps,
            sx: {
              height: 'auto', // Define a altura do input
              padding: '0', // Ajuste o padding para que o campo não fique com bordas muito grandes
            },
          }}
          sx={{
            '& .MuiOutlinedInput-root': {
              height: 44, // Controla a altura do campo de input
            },
          }}
        />
      )}
      //   autoComplete="off"
    />
  );
}
